<template>
  <div class="inquiry-list-page">
    <TableList :tableData="tableData" :tablePagination="tablePagination" @getTableData="getAllData"
               v-loading="loading"    @activeName="activeName" :isActive="isActive" @rowDbclick="rowDbclick"
               :categoryType="'normal'" :type="'my'" theme="pink"/>
    <el-dialog
      :visible.sync="dialogVisible"
      fullscreen
    >
      <product-details @handleButton="handleButton" :previewData="previewData"
                       :loading="loading" @close="dialogVisible=false"></product-details>
    </el-dialog>
    <el-dialog
      :visible.sync="brandVisible"
      fullscreen
    >
      <brand-details @handleButton="handleButton" :previewData="previewData"
                     :loading="loading" @close="dialogVisible=false"></brand-details>
    </el-dialog>

  </div>
</template>

<script>
import TableList from './components/tableList'
import { mapGetters } from 'vuex'
import ProductDetails from '@/pages/inquiries/productDetails.vue'
import brandDetails from '@/pages/inquiries/brandDetails.vue'


export default {
  name: 'inquiryList',
  components: { ProductDetails, TableList, brandDetails },
  computed: {
    ...mapGetters(['userPermissions', 'userInfo'])
  },
  data() {
    return {
      tableData: [],
      drawerVisible: false,
      rowId: 'add',
      tablePagination: {
        total: 0,
        page_size: 15,
        offset: 0,
        current_page: 1
      },
      isActive: 'my',
      dialogVisible: false,
      previewPagination: {},
      previewData: {},
      loading: false,
      brandVisible: false
    }
  },
  watch: {
    drawerVisible: {
      deep: true,
      handler() {
        this.infoData()
      }
    }
  },
  methods: {
    handleButton(type) {
      const current_page = this.previewPagination.current_page
      this.loading = true
      if (type === 'preBtn') {
        if (current_page != 1)
          this.previewPagination.current_page = current_page - 1
        else {
          this.previewPagination.current_page = 1
        }
      } else {
        if (this.previewPagination.current_page !== this.previewPagination.total) {
          this.previewPagination.current_page = this.previewPagination.current_page + 1
        }
      }
      this.getAllData(this.previewPagination, 'preview')
    },
    async rowDbclick(index) {
      this.previewPagination = JSON.parse(JSON.stringify(this.tablePagination))
      this.previewPagination.page_size = 1
      this.previewPagination.current_page = index + 1
      await this.getAllData(this.previewPagination, 'preview')
    },
    activeName(val) {
      this.isActive = val
      this.getAllData()
    },
    async getAllData(val, type) {
      this.loading=true

      let searchCondition
      if (!val) {
        searchCondition = {
          page_size: 15,
          current_page: 1
        }
      } else searchCondition = val
      //普通询单=1 全案询单=2
      searchCondition.type = 1
      let data
      if (this.isActive === 'all') {
        data = await this.$api.listInquiryProject(searchCondition)
      }
      if (this.isActive === 'my') {
        data = await this.$api.listInquiryOwner(searchCondition)
      } else if (this.isActive === 'myGroup') {
        data = await this.$api.ownerGroup(searchCondition)
      }
      const list = data.list
      const page_info = data.page_info

      const convertData = ['is_assign', 'is_platform_pay', 'is_send_back', 'is_cart', 'is_auth_price']
      list.forEach((item) => {
        convertData.forEach((i) => {
          if (i === 'is_assign' || i === 'is_send_back') {
            item[i] = item[i] === 1 ? '是' : '否'
          } else item[i] = item[i] === 2 ? '是' : '否'
        })
      })
      if (type === 'preview') {
        this.previewData = list[0]
        this.previewPagination = page_info
        this.loading = false
        this.previewData.product_num === 1 ? this.dialogVisible = true : this.brandVisible = true
      } else {
        this.tableData = list
        this.tablePagination = page_info
      }
      this.loading=false
    }
  },
  mounted() {
    this.getAllData()
  }
}
</script>

<style scoped>
::v-deep .el-dialog__body {
  padding: 2px 20px;
}
</style>

<style>
.inquiriesList_main-content {
  overflow: hidden;
}
</style>
